<ng-container *ngIf="isLoaded">
  <ng-container *ngFor="let component of page.components; let i = index">
    <ng-container *ngTemplateOutlet="uiComponent; context: {component: component, parent: page }"></ng-container>
  </ng-container>
</ng-container>


<!-- TEMPLATES -->
<ng-template #uiComponent let-component="component" let-parent="parent">
  <ng-container [ngSwitch]="component.componentConfig.type">

    <ng-container *ngSwitchCase="'ui-slider'">
      <ui-slider [component]="component" [parent]="parent">
        <ng-container *ngTemplateOutlet="children; context: {component: component}"></ng-container>
      </ui-slider>
    </ng-container>

    <ng-container *ngSwitchCase="'ui-grid'">
      <ui-grid [component]="component" [parent]="parent">
        <ng-container *ngTemplateOutlet="children; context: {component: component}"></ng-container>
      </ui-grid>
    </ng-container>

    <ng-container *ngSwitchCase="'ui-card'">
      <ui-card [component]="component" [parent]="parent" *ngIf="component.content.image">
        <ng-container *ngTemplateOutlet="children; context: {component: component}"></ng-container>
      </ui-card>
    </ng-container>

    <ng-container *ngSwitchCase="'ui-post'">
      <ui-post [component]="component" [parent]="parent">
        <ng-container *ngTemplateOutlet="children; context: {component: component}"></ng-container>
      </ui-post>
    </ng-container>

    <ng-container *ngSwitchCase="'ui-container'">
      <ui-container [component]="component" [parent]="parent">
        <ng-container *ngTemplateOutlet="children; context: {component: component}"></ng-container>
      </ui-container>
    </ng-container>

    <ng-container *ngSwitchCase="'ui-header'">
      <!-- STATIC -->
    </ng-container>
    <ng-container *ngSwitchCase="'ui-footer'">
      <!-- STATIC -->
    </ng-container>

    <ng-container *ngSwitchCase="'cs-static'">
      <cs-static [component]="component" [parent]="parent">
        <ng-container *ngTemplateOutlet="children; context: {component: component}"></ng-container>
      </cs-static>
    </ng-container>

  </ng-container>
</ng-template>


<ng-template #children let-component="component">
  <ng-container *ngIf="component.children && component.children.length > 0">
    <ng-container *ngFor="let child of component.children">
      <ng-container *ngTemplateOutlet="uiComponent; context: {component: child, parent: component}"></ng-container>
    </ng-container>
  </ng-container>
</ng-template>